export default __webpack_public_path__ + "static/media/grey.7c4b6ec7.svg";